import { createAction } from '@mews/framework';
import { BODY_CELL_SELECTED, CELL_SELECTION_RESET } from '../actionTypes';
import { isAnyCellSelected } from '../selectors';
import { dispatchWithCellSelectedTracking } from './analyticsTracking';

export const selectBodyCell = (cellPosition: $TSFixMe, scope: $TSFixMe) =>
    dispatchWithCellSelectedTracking(cellPosition)(createAction(BODY_CELL_SELECTED, cellPosition, { scope }));

export const resetCellSelection = (scope: $TSFixMe) => (dispatch: $TSFixMe, getState: $TSFixMe) => {
    if (isAnyCellSelected(getState(), { serviceId: scope })) {
        dispatch(createAction(CELL_SELECTION_RESET, null, { scope }));
    }
};
